import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NbButtonModule } from '@nebular/theme';

@Component({
    selector: 'app-open-price-sheets-renderer',
    template: `
    @if (!!priceSheetsCount) {
      <button nbButton ghost (click)="openPriceSheets()">
        <span class="ms-1">{{ priceSheetsCount }}</span>
      </button>
    }
    `,
    styles: [`
      button {
        background-color: transparent !important;
        padding: 0 !important;
        top: 4px !important;
        position: absolute !important;
        left: 0 !important;
        right: 0 !important;
        color: #000 !important;
        align-items: self-end;
      }

      span {
        text-decoration: underline;
      }
    `],
    standalone: true,
    imports: [
      NbButtonModule,
      FontAwesomeModule
    ],
})
export class OpenPriceSheetsRendererComponent implements ICellRendererAngularComp {

  @ViewChild('container', { read: ViewContainerRef })
  public container!: ViewContainerRef;
  public priceSheetsCount: number;
  public fromAssetTable: boolean = false;
  private params: any;

  agInit(params: any): void {
    this.params = params;
    this.priceSheetsCount = this.params.data.price_sheets_count;
    this.fromAssetTable = this.params.fromAssetTable
  }

  refresh(): boolean {
    return false;
  }

  public openPriceSheets(): void {
    if (this.fromAssetTable) {
      return
    } else {
      this.params.context.openPriceSheets(
        this.params.node.data.id,
      );
    }
  }
}
